import { cn } from "@/frontend/lib/utils";

type StatusType = "pending" | "approved" | "rejected" | "active" | "inactive" | "blocked" | "draft" | "published";

interface StatusBadgeProps {
  status: StatusType;
  className?: string;
}

const statusConfig: Record<StatusType, { label: string; className: string }> = {
  pending: {
    label: "Pending",
    className: "bg-amber-100 text-amber-800 border-amber-200",
  },
  approved: {
    label: "Approved",
    className: "bg-emerald-100 text-emerald-800 border-emerald-200",
  },
  rejected: {
    label: "Rejected",
    className: "bg-red-100 text-red-800 border-red-200",
  },
  active: {
    label: "Active",
    className: "bg-emerald-100 text-emerald-800 border-emerald-200",
  },
  inactive: {
    label: "Inactive",
    className: "bg-muted text-muted-foreground border-border",
  },
  blocked: {
    label: "Admin block",
    className: "bg-slate-200 text-slate-700 border-slate-300",
  },
  draft: {
    label: "Draft",
    className: "bg-amber-100 text-amber-800 border-amber-200",
  },
  published: {
    label: "Published",
    className: "bg-emerald-100 text-emerald-800 border-emerald-200",
  },
};

export const StatusBadge = ({ status, className }: StatusBadgeProps) => {
  const config = statusConfig[status];

  return (
    <span
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border",
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
};
